module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.2998a1bb.png";